import React, { useState, useEffect } from 'react';
import axios from 'axios';
// import "./ExchangeRate.css"
import { ReactComponent as ArrowBottom } from "../../assets/icons/main/main-arrow-bottom.svg"
import {getPriceChangeClass} from "../../features/getPriceChangeClass";

const MarketHeader = ({setMarketState, AVGdata, coinTo}) => {
    const [marketInfo, setMarketInfo] = useState(null);
    const [isLoadedMarketInfo, setIsLoadedMarketInfo] = useState(false);

    const urlParams = new URLSearchParams(window.location.search);
    const symbol = urlParams.get('resource') || 'GOLDUSD';

    return (
        <div className="exchangeRate">


            <ul>
                <li className='BTC-USDT'>
                    {/* {
                        coinTo && <img src={`https://api-ru.fynex.cc/api/static/icons/${coinTo.toLowerCase()}.png`} alt="" /> 
                    } */}
                    <h3>{symbol.replace(/USD$/, '/USD')}</h3> <ArrowBottom onClick={() => setMarketState(true)}/></li>
                <li>
                    <h2>{Number(AVGdata.lastPrice).toLocaleString()}</h2>
                </li>
            </ul>
        </div>)
};

export default MarketHeader;
